import 'deepmerge';

function isValueInPixel(value) {
    return /^(\d)+px$/.test(value);
}
function isArFontSize(value) {
    return ['xl', 'lg', 'md', 'sm', 'xs', 'xxs', 'xxxs'].indexOf(value) > -1
        || isValueInPixel(value);
}

var ARTextarea = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:[
    'ar-textarea',
    _vm.isFocused && 'is-focused' ],attrs:{"ar-widget-id":"ar-tetextareaxt","ar-widget-meta":_vm.arWidgetMeta || _vm.computedArWidgetMeta,"name":"ar-textarea"}},[_c('textarea',{staticClass:"textarea",style:({
      fontSize: _vm.inputFontSizeInPixel,
    }),attrs:{"placeholder":_vm.placeholder,"rows":_vm.rows,"maxlength":_vm.maxLength || 999999,"disabled":_vm.disabled},domProps:{"value":_vm.realValue},on:{"input":_vm.handleInput,"focus":_vm.handleTextAreaFocus,"blur":_vm.handleTextAreaBlur}}),_vm._v(" "),(_vm.charactersLeftInTemplate)?_c('ar-text',{staticClass:"left-text",attrs:{"size":"xs","text":(_vm.charactersLeftInTemplate + " characters left"),"align":"right"}}):_vm._e()],1)},
staticRenderFns: [],
  name: 'Textarea',
  props: {
    arWidgetMeta: String,
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    inputFontSize: {
      type: String,
      default: 'xs',
      validator: isArFontSize,
    },
    rows: {
      type: Number,
      default: 2,
    },
    maxLength: {
      type: Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isFocused: false,
      realValue: null,
    };
  },

  computed: {
    computedArWidgetMeta() {
      return [
        `placeholder=${this.placeholder};`,
        `value=${this.realValue};`,
      ].join('');
    },
    charactersLeftInTemplate() {
      if (typeof this.maxLength !== 'number') {
        return null;
      }
      return (this.maxLength - (this.realValue ? this.realValue.length : 0)).toString();
    },
    inputFontSizeInPixel() {
      return this.$arStyle.font.size[this.inputFontSize] || this.inputFontSize;
    },
  },

  watch: {
    value: {
      handler(val) {
        this.realValue = val;
      },
      immediate: true,
    },
  },
  methods: {
    handleTextAreaFocus() {
      this.isFocused = true;
      this.$emit('focus');
    },
    handleTextAreaBlur() {
      this.isFocused = false;
      this.$emit('blur');
    },
    handleInput(event) {
      this.realValue = event.target.value;
      this.$emit('input', event.target.value);
    },
  },
};

export default ARTextarea;
